import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createReignite(): DrawFn {
  const rng = mulberry32(18)
  const ash = Array.from({ length: 50 }, () => ({
    x: rng(),
    y: rng() * 0.5 + 0.35,
    s: 0.5 + rng() * 1.4,
    o: rng() * TAU,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.48
    ctx.clearRect(0, 0, w, h)
    const flame = easeOutCubic(clamp((t - 0.6) / 1.4))
    const pulse = 0.85 + Math.sin(t * 2.6) * 0.15

    ctx.globalCompositeOperation = 'source-over'
    for (const a of ash) {
      const tw = 0.15 + 0.15 * Math.sin(t * 0.8 + a.o)
      ctx.fillStyle = `rgba(160,150,140,${tw})`
      ctx.beginPath()
      ctx.arc(a.x * w, a.y * h, a.s, 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, cy, 70 * flame * pulse, 'rgba(255,90,20,0.22)')
    glow(ctx, cx, cy - 8, 16 * flame * pulse, 'rgba(255,220,140,0.8)')

    if (flame > 0) {
      ctx.beginPath()
      ctx.moveTo(cx, cy - 28 * flame * pulse)
      ctx.quadraticCurveTo(cx + 7 * flame, cy - 8, cx, cy + 4)
      ctx.quadraticCurveTo(cx - 7 * flame, cy - 8, cx, cy - 28 * flame * pulse)
      ctx.fillStyle = `rgba(255,170,60,${0.85 * flame})`
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
